import {
  FieldError,
  Response,
  Specialty,
  ValidationErrors
} from './types';

export class ApiError extends Error {
  constructor(readonly status: number, readonly body: Response<unknown> | null) {
    super(`XHR error: ${status}`);
  }

  get validationErrors(): FieldError[] | null {
    if (this.status !== 422) return null;
    const data = this.body?.data as ValidationErrors | null | undefined;
    return data?.errors ?? null;
  }
}

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

interface ApiClientOptions {
  method?: HttpMethod;
  body?: any;
  headers?: Record<string, string>;
}

export const apiClient = async <T>(
  endpoint: string,
  options: ApiClientOptions = {}
): Promise<Response<T>> => {
  const { method = 'GET', body, headers = {} } = options;

  const requestOptions: RequestInit = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (body) {
    requestOptions.body = JSON.stringify(body);
  }

  const response = await fetch(window.__ENV__.API_URL + endpoint, requestOptions);

  if (!response.ok) {
    throw new ApiError(response.status, await response.json().catch(() => null));
  }

  return response.json();
};


export const endpoints = {
  sendForm: (body: any, lang: string) =>
    apiClient<null>(`/api/v4/expert/self-registration?lang=${lang}`, { method: 'POST', body }),
  getSpecialties: (lang: string) => apiClient<{list: Specialty[]}>(`/api/v4/consultation/specialities?lang=${lang}`),
};
